/** Typed access to build-time environment variables (only VITE_* reach the browser). */
export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api/v1',
} as const;
